import Vue from "vue";
import { Reader } from "../Reader";
import { autoId } from "@/lib/autoId";
import { Project } from "./Project";
import { Time } from "@/lib/Time";

export class ProjectReader extends Reader {
  _userId;
  data = {};

  constructor({ userId } = {}) {
    super();
    if (userId == undefined) {
      throw Error("userId is required in ProjectReader");
    }
    this._userId = userId;
  }
  start() {
    let { p, done } = this._makeReadyPromise();
    this._setStatusRunning();
    this._firestore.collection(`users/${this._userId}/projects`).onSnapshot(
      querySnapshot => {
        Vue.set(this, "data", {});
        querySnapshot.forEach(doc => {
          let project = new Project(doc.ref.path);
          project.updateData(Time.date.firebaseTimestampsToDate(doc.data()));
          Vue.set(this.data, doc.id, project);
        });
        this._setStatusReady();
        done();
      },
      error => {
        console.error("ProjectReader Error: ", error);
      }
    );

    return p;
  }
  getByProjectId(projectId) {
    return this.data[projectId];
  }

  create() {
    let p = new Project(`users/${this._userId}/projects/${autoId()}`);
    p.updateData({ userId: this._userId });
    return p;
  }
}
